import { useEffect } from 'react';
import { UserManager } from 'oidc-client-ts';
import { getOidcConfig } from './oidcConfig';

export const LoginCallback = () => {
    useEffect(() => {
        const handleCallback = async () => {
            try {
                const oidcConfig = getOidcConfig();
                const userManager = new UserManager({
                    authority: '',
                    ...oidcConfig
                });
                
                await userManager.signinCallback();
            } catch (error) {
                console.error('ProjectApproval_ Error handling signin callback:', error);
            }
        };

        handleCallback();
    }, []);

    return null;
};